// Search and paging helpers for the User, Common, Branch and Receivable
// configuration tables

// Rows-per-page choices of the shared table, plus one that shows every row
export const ROWS_PER_PAGE_WITH_ALL = [
  5,
  10,
  25,
  50,
  100,
  { label: "All", value: -1 },
];

// True when every word of the search text is found somewhere in the row's
// values, so "abirami goods" matches a row holding both in different columns.
// `keys` are the row fields to look in: the shown columns plus hidden parts
// such as the sub booking code.
export const rowMatchesSearch = (row, keys, searchText) => {
  const words = String(searchText || "")
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
  if (!words.length) return true;
  const rowText = keys
    .map((key) => String(row?.[key] ?? ""))
    .join(" ")
    .toLowerCase();
  return words.every((word) => rowText.includes(word));
};
